export default {
  install(Vue) {
    Vue.prototype.$common = {
      parsePermission: permission => {
        switch (permission) {
          case "role_tbc":
            return "待認證";
          case "role_user":
            return "使用者";
          case "role_staff":
            return "員工";
          case "role_admin":
            return "診所管理者";
          case "role_superadmin":
            return "系統管理者";
        }
      },
      parsePetAge: birth => {
        let year = birth.substring(0, 4);
        let month = birth.substring(5, 7);
        let date = birth.substring(8, 10);

        let diffInDay =
          (new Date().getTime() -
            new Date(year, month - 1, date, 0, 0, 0, 0).getTime()) /
          (1000 * 3600 * 24);

        let yearAge = Math.floor(diffInDay / 365);
        let monthAge = Math.floor((diffInDay - yearAge * 365) / 30);

        if (diffInDay < 365) {
          return `${monthAge}m`;
        } else {
          return `${yearAge}y${monthAge}m`;
        }
      }
    };
  }
};
